/**/
$(document).ready(function () {
    /* Scroll to join Senat -- start */
    $("a.mission__btn").on("click", function (e) {
        e.preventDefault();

        let href = $(this).attr("href");

        $("html, body").animate({
            scrollTop: $(href).offset().top-230
        }, {
            duration: 370,
            easing: "linear"
        });

        return false;
    });
    /* Scroll to join Senat -- end */

    /*---*/
    let scrolling = true;

    function circularProgressing() {
        if (scrolling) {
            let circularProgress = document.querySelector(".circular-progress"),
                progressValue = document.querySelector(".progress-value-num");

            let progressStartValue = 0,
                progressStartValue_fraction = 0,
                progressEndValue = 83,
                progressEndValue_fraction = 3,
                speed = 10;

            let progressA = setInterval(() => {
                progressStartValue_fraction++;

                if (progressStartValue_fraction == progressEndValue_fraction) {
                    clearInterval(progressA);
                }

            }, speed);

            let progress = setInterval(() => {
                progressStartValue++;

                progressValue.textContent = `${progressStartValue}.${progressStartValue_fraction}`
                circularProgress.style.background = `conic-gradient(#C98660 ${progressStartValue * 3.6}deg, #ededed 0deg)`

                if (progressStartValue == progressEndValue) {
                    clearInterval(progress);
                }
            }, speed);
        }

        scrolling = false;
    };

    let windowHeight = $(window).height();
    if ($('#jobsReviewsCounter').length) {
        $(document).on('scroll', function() {
            var self = $('#jobsReviewsCounter'),
                height = self.offset().top + self.height();
            if ($(document).scrollTop() + windowHeight >= height) {
                self.addClass('animate');
                circularProgressing();
            }
        });
    }
});
